import React, { useState } from "react";
import Home from "./Pages/Home";
import { Routes, Route, Navigate } from "react-router-dom";
import AboutPage from "./Pages/AboutPage";
import SignUpModal from "./utils/SignUpModal";
import { useModal } from "./context/ModalContext";
import Team from "./Pages/Team";

export default function Router() {
  const [darkToggle, setDarkToggle] = useState(true);
  const [enteredAmount, setEnteredAmount] = useState();
  const [convertedCoins, setConvertedCoins] = useState();

  const {
    SignUpModalvisibility,
  } = useModal();

  return (
    <div className={`${darkToggle && "dark bg-primary"}`}>
      {SignUpModalvisibility && <SignUpModal />}
      <Routes>
       
       


        <Route
          path="/"
          element={
            <Home
              darkToggle={darkToggle}
              setEnteredAmount={setEnteredAmount}
              enteredAmount={enteredAmount}
              convertedCoins={convertedCoins}
              setConvertedCoins={setConvertedCoins}
              setDarkToggle={setDarkToggle}
            />
          }
        />

        <Route
          path="/about"
          element={
            <AboutPage darkToggle={darkToggle} setDarkToggle={setDarkToggle} />
          }
        />

      <Route
          path="/team/:id"
          element={
            <Team darkToggle={darkToggle} setDarkToggle={setDarkToggle} />
          }
        />


      </Routes>
    </div>
  );
}
